const urlMap = {
  AdGroupTab: {
    urlVNext: 'campaign/vnext/adgroups?cid={cid}&uid={uid}&aid={aid}&campaignId={0}',
    isOriginRequired: true,
  },
  Opportunity: {
    urlVNext: 'campaign/vnext/recommendations/All?aid={aid}&cid={cid}&uid={uid}&recommendationType={0}&src=inlineopportunity&recsrc=PerformanceFluctuations',
    isOriginRequired: true,
  },
  CompetitionOpportunity: {
    urlVNext: 'campaign/vnext/competitionrecommendations?aid={aid}&cid={cid}&uid={uid}&recommendationType={0}&src=inlineopportunity&recsrc=PerformanceFluctuations',
    isOriginRequired: true,
  },
  FixConversionGoalSettingsOpportunity: {
    urlVNext: 'campaign/vnext/recommendations/All?aid={aid}&cid={cid}&recommendationType=FixConversionGoalSettingsOpportunity&uid={uid}',
    isOriginRequired: true,
  },
  WebsiteReport: {
    urlVNext: 'campaign/vnext/dimensions/publisherwebsite?cid={cid}&uid={uid}&aid={aid}',
    isOriginRequired: true,
  },
  AdGroupSettingsTab: {
    urlVNext: 'campaign/vnext/settings?adGroupId={adgid}&cid={cid}&uid={uid}&aid={aid}&campaignId={cmpid}',
    isOriginRequired: true,
  },
  CampaignSettingsTab: {
    urlVNext: 'campaign/vnext/settings?cid={cid}&uid={uid}&aid={aid}&campaignId={cmpid}',
    isOriginRequired: true,
  },
  KeywordTab: {
    urlVNext: 'campaign/vnext/keywords?adGroupId={adgid}&aid={aid}&campaignId={cmpid}&cid={cid}&uid={uid}',
    isOriginRequired: true,
  },
  CampaignTab: {
    urlVNext: 'campaign/vnext/campaigns?aid={aid}&cid={cid}&uid={uid}',
    isOriginRequired: true,
  },
  AdGroupAcctLevelTab: {
    urlVNext: 'campaign/vnext/adgroups?aid={aid}&cid={cid}&uid={uid}',
    isOriginRequired: true,
  },
  AdGroupCampaignLevelTab: {
    urlVNext: 'campaign/vnext/adgroups?aid={aid}&cid={cid}&uid={uid}&campaignId={cmpid}',
    isOriginRequired: true,
  },
  KeywordCampaignLevelTab: {
    urlVNext: 'campaign/vnext/keywords?aid={aid}&campaignId={cmpid}&cid={cid}&uid={uid}',
    isOriginRequired: true,
  },
  KeywordAcctLevelTab: {
    urlVNext: 'campaign/vnext/keywords?aid={aid}&cid={cid}&uid={uid}',
    isOriginRequired: true,
  },
  AdTab: {
    urlVNext: 'campaign/vnext/ads?aid={aid}&cid={cid}&uid={uid}',
    isOriginRequired: true,
  },
  AdCampaignLevelTab: {
    urlVNext: 'campaign/vnext/ads?aid={aid}&campaignId={cmpid}&cid={cid}&uid={uid}',
    isOriginRequired: true,
  },
  AdAcctLevelTab: {
    urlVNext: 'campaign/vnext/ads?aid={aid}&cid={cid}&uid={uid}',
    isOriginRequired: true,
  },
  ChangeHistory: {
    urlVNext: 'campaign/vnext/changehistory?aid={aid}&cid={cid}&uid={uid}',
    isOriginRequired: true,
  },
  AuctionInsight: {
    urlVNext: 'campaign/vnext/keywordsauction?aid={aid}&cid={cid}&uid={uid}',
    isOriginRequired: true,
  },
  SearchTerm: {
    urlVNext: 'campaign/vnext/dimensions/searchtermsdimensions?aid={aid}&cid={cid}&uid={uid}',
    isOriginRequired: true,
  },
  InvoiceAccountPausedActionURLId: {
    urlVNext: '/cc/InsertionOrder?aid={aid}&cid={cid}&uid={uid}',
    isOriginRequired: true,
  },
  InvoiceAccountOnHoldActionURLId: {
    urlVNext: '/cc/CreditHold/Dashboard?cid={cid}&uid={uid}&rurl=fluctuation',
    isOriginRequired: true,
  },
  PrepayAccountPausedActionURLId: {
    urlVNext: '/cc/Payment/Prepay?aid={aid}&cid={cid}&uid={uid}&returnUrl=fluctuation',
    isOriginRequired: true,
  },
  ThresholdAccountOnHoldActionURLId: {
    urlVNext: '/cc/CreditHold/Dashboard?cid={cid}&uid={uid}&rurl=fluctuation',
    isOriginRequired: true,
  },
  learnmoreLink: {
    urlVNext: 'https://help.bingads.microsoft.com/#apex/3/en/{0}/1/en-US/#ext:campaigns_load',
    isOriginRequired: false,
  },
  FixConversionGoalSettingLearnMore: {
    urlVNext: 'https://help.bingads.microsoft.com/#apex/ads/en/60029/1/en-US/#ext:recommendations_All',
    isOriginRequired: false,
  },
  CreatedNewConversionGoalLearnMore: {
    urlVNext: 'https://help.bingads.microsoft.com/#apex/ads/en/60029/1/en-US/#ext:recommendations_All',
    isOriginRequired: false,
  },
  InvoiceAccountPausedActionHelperId: {
    urlVNext: 'app50035',
    isOriginRequired: false,
  },
  InvoiceAccountOnHoldActionHelperId: {
    url: 'app50043',
    urlVNext: 'app50043',
    isOriginRequired: false,
  },
  PrepayAccountPausedActionHelperId: {
    urlVNext: 'app50053',
    isOriginRequired: false,
  },
  ThresholdAccountOnHoldActionHelperId: {
    urlVNext: 'app50043',
    isOriginRequired: false,
  },
};

export class FluctuationUrlService {
  getUrl(urlId) {
    if (!urlMap[urlId] || !urlMap[urlId].urlVNext) {
      return null;
    }

    // urlMap[urlId].urlVNext hasn't slash and urlMap[urlId].url has
    // should confirm only both have only one slash
    const { urlVNext, isOriginRequired } = urlMap[urlId];
    const addSlashPrefix = u => (u.startsWith('/') || u.startsWith('https') ? u : `/${u}`);
    const urlWithSlash = addSlashPrefix(urlVNext);

    return `${isOriginRequired ? window.location.origin : ''}${urlWithSlash}`;
  }

  get allCampaignsUrl() {
    return this.getUrl('CampaignTab');
  }
}
